function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys, key, i;
    if (typeof Reflect !== "undefined" && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(Object(source));
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
        return target;
    }
    target = _object_without_properties_loose(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
export const ProjectIcon = (_0)=>{
    let { color = '#7B84A3' } = _0, props = _object_without_properties(_0, [
        "color"
    ]);
    var _props_width, _props_width1;
    return /*#__PURE__*/ _jsx("svg", _object_spread_props(_object_spread({
        width: (_props_width = props.width) !== null && _props_width !== void 0 ? _props_width : 16,
        height: (_props_width1 = props.width) !== null && _props_width1 !== void 0 ? _props_width1 : 17,
        viewBox: "0 0 17 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "M17.4539 5.93081C17.4539 5.93081 17.4539 5.93081 17.4539 5.86012L17.4009 5.72756C17.3824 5.69944 17.3617 5.67284 17.3391 5.64803C17.3154 5.61062 17.2888 5.57516 17.2595 5.54199L17.18 5.48013L17.0386 5.40943L10.4109 1.31792C10.2704 1.23014 10.1082 1.18359 9.94249 1.18359C9.7769 1.18359 9.61457 1.23014 9.47415 1.31792L2.89945 5.40943L2.81992 5.48013L2.74039 5.54199C2.71109 5.57516 2.6845 5.61062 2.66085 5.64803C2.63813 5.67284 2.61745 5.69944 2.599 5.72756L2.54597 5.86012C2.54597 5.86012 2.54597 5.86012 2.54597 5.93081C2.53729 6.00715 2.53729 6.08423 2.54597 6.16057V13.8841C2.54567 14.0342 2.58365 14.182 2.65632 14.3135C2.72899 14.4449 2.83396 14.5557 2.96131 14.6352L9.58899 18.7267C9.62982 18.7519 9.67465 18.7698 9.72157 18.7797C9.72157 18.7797 9.76574 18.7797 9.79224 18.7797C9.94182 18.8272 10.1023 18.8272 10.2518 18.7797C10.2518 18.7797 10.296 18.7797 10.3225 18.7797C10.3694 18.7698 10.4142 18.7519 10.4551 18.7267L17.0386 14.6352C17.1659 14.5557 17.2709 14.4449 17.3436 14.3135C17.4162 14.182 17.4542 14.0342 17.4539 13.8841V6.16057C17.4626 6.08423 17.4626 6.00715 17.4539 5.93081ZM9.08532 16.3937L4.225 13.3892V7.75123L9.08532 10.747V16.3937ZM9.96899 9.21816L5.02032 6.16057L9.96899 3.11182L14.9177 6.16057L9.96899 9.21816ZM15.7131 13.3892L10.8527 16.3937V10.747L15.7131 7.75123V13.3892Z",
            fill: color
        })
    }));
};
